
































import mixins from 'vue-typed-mixins'
import ExerciseMixin from '../../ExerciseMixin'
export default mixins(ExerciseMixin).extend({})
